import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getCookie } from "../../utils/cookie";
import { isSessionExpired } from "../../utils/session";

type TProps = {
  children: React.ReactElement;
};

const ProtectedRoute: React.FC<TProps> = ({ children }) => {
  const location = useLocation();
  const token = getCookie();

  // Presence alone is not enough: admin tokens expire after 24h and there is no
  // refresh, so a stale cookie would render the whole app shell only for every
  // request behind it to fail with a 401.
  if (!token || isSessionExpired(token)) {
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
